import React from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import { SCHEMA_SHAPE } from '../../shapes'
import {
  GRAPH_FILL_STYLES, GRAPH_STROKE_STYLES
} from '../constants'

export default class GraphKeyEntry extends React.PureComponent {
  static propTypes = {
    schema: SCHEMA_SHAPE.isRequired,
    highlightedPathKey: T.string,
    dataKey: T.string.isRequired,
    styles: IT.map.isRequired,
    onMouseOver: T.func,
    onMouseMove: T.func,
    onMouseOut: T.func
  }

  handleMouseOver = () => {
    const {
      dataKey,
      onMouseOver
    } = this.props
    onMouseOver(dataKey)
  }

  handleMouseMove = () => {
    const {
      dataKey,
      onMouseMove
    } = this.props
    onMouseMove(dataKey)
  }

  handleMouseOut = () => {
    const {
      dataKey,
      onMouseOut
    } = this.props
    onMouseOut(dataKey)
  }

  render() {
    const {
      schema,
      highlightedPathKey,
      dataKey,
      styles
    } = this.props

    return (
      <div
        className={`graph_key_entry ${highlightedPathKey === dataKey ? 'highlighted_path' : ''}`}
        onMouseOver={this.handleMouseOver}
        onMouseMove={this.handleMouseMove}
        onMouseOut={this.handleMouseOut}
        key={dataKey}
      >
        <span
          className="key_indicator"
          style={{
            borderTop: `${Math.ceil(styles.get('strokeWidth', 1))}px ${styles.get('strokeStyle') ===  GRAPH_STROKE_STYLES.DASHED ? 'dashed' : 'solid'} ${styles.get('strokeColor')}`,
            background: styles.get('fillStyle', GRAPH_FILL_STYLES.GRADIENT) === GRAPH_FILL_STYLES.GRADIENT ? `linear-gradient(180deg, ${styles.get('fillColor')}, transparent)` : styles.get('fillColor')
          }}
        /> {schema.get(dataKey).get('display')}
      </div>
    )
  }
}